// PLAIN WORDS FOR EVERY PLACE (his design, 21 Oct — /review/setting-up-places/). One line each, shown where you pick
// them. Read from what is stored; nothing stored changes. The backend's kind_of() in place_setup.py is the twin.
export const PLACE_WORDS = {
  property: { word: "Property", line: "A whole address, like Royalton or Rice. Everything else sits inside one." },
  zone: { word: "Zone", line: "A big area of a property — the Warehouse, the Yard, the East Apron. A yard sector where trucks park is a zone." },
  rack: { word: "Pallet rack", line: "Racking that is built in and never moves — bays across, levels up." },
  shelf_unit: { word: "Shelf unit", line: "Shelving that is built in and never moves." },
  bay: { word: "Bay", line: "One section of a pallet rack between two uprights, numbered 1, 2, 3… from the left." },
  level: { word: "Level", line: "The exact place on a bay a part goes. This is what you scan." },
  shelf: { word: "Shelf", line: "One shelf of a shelf unit. This is what you scan." },
  spot: { word: "Spot", line: "One place you scan a part into, like a floor spot." },
  holder: { word: "Holder", line: "Anything that holds parts and can be picked up and moved — tote, pallet, bin, stack rack, glass rack." },
  slot: { word: "Slot", line: "One divided space inside a holder. Parts are scanned into a slot." },
};

// WHAT CAN GO WHERE — the sheet offers only these. A pallet rack grows only through its own menu.
export const CAN_ADD = {
  property: ["zone", "holder"], zone: ["zone", "pallet_rack", "shelf_unit", "spot", "holder"],
  shelf_unit: ["shelves"], level: ["holder"], shelf: ["holder"], spot: ["holder"], slot: ["holder"],
  holder: ["slots", "holder"], rack: [],
};

export const ADD_WORDS = {
  zone: { word: "Zone", line: PLACE_WORDS.zone.line },
  pallet_rack: { word: "Pallet rack", line: "Bays × levels. Every position gets its code the one way, made by the app." },
  shelf_unit: { word: "Shelf unit", line: PLACE_WORDS.shelf_unit.line },
  spot: { word: "Spot", line: PLACE_WORDS.spot.line },
  holder: { word: "Holder", line: PLACE_WORDS.holder.line },
  slots: { word: "Slots", line: "More divided spaces inside this holder, carrying on its numbers." },
  shelves: { word: "Shelves", line: "More shelves on this shelf unit, carrying on its numbers." },
};

const POS = /-R[1-9]\d*-B([1-9]\d*)-([0A-Z])$/;
export const bayOf = (code) => { const m = POS.exec(code || ""); return m ? Number(m[1]) : null; };
export const levelOf = (code) => { const m = POS.exec(code || ""); return m ? (m[2] === "0" ? "Floor" : `Level ${m[2]}`) : null; };

const ancestors = (node, locById) => {
  const out = [];
  let cur = node;
  const seen = new Set();
  while (cur?.parent_id && !seen.has(cur.parent_id)) {
    seen.add(cur.parent_id);
    cur = locById[cur.parent_id];
    if (cur) out.push(cur);
  }
  return out;
};

export function kindOf(node, locById = {}) {
  if (!node) return "spot";
  if (node.type === "site") return "property";
  if (node.type === "zone") return "zone";
  if (node.type === "container") return "holder";
  const anc = ancestors(node, locById);
  if (anc.some((a) => a.type === "container")) return "slot";
  if (node.type === "structure") return node.racking === "rack" ? "rack" : "shelf_unit";
  if (node.racking === "position" || bayOf(node.short_code)) return "level";
  return anc[0]?.type === "structure" ? "shelf" : "spot";
}

/** The word on a row: "Level C" for a rack position, else the kind's own word. */
export const rowWord = (node, kind) => (kind === "level" ? levelOf(node.short_code) || "Level" : PLACE_WORDS[kind]?.word || kind);

const plainBits = (n) => (bayOf(n.short_code) ? [`Bay ${bayOf(n.short_code)}`, levelOf(n.short_code)] : [n.name || n.short_code]);

/** "Royalton › Yard › East Apron › Pallet Rack 1 › Bay 3 › Level C" */
export function plainPath(node, locById = {}) {
  if (!node) return "";
  return [...ancestors(node, locById).reverse(), node].flatMap(plainBits).join(" › ");
}
